export default function TrialFlowSection() {
  const steps = [
    {
      number: '01',
      title: 'お申し込み',
      description: 'ホームページ、お電話、LINEからお気軽にお申し込みください。ご希望の日時をお伺いします。',
      icon: 'ri-smartphone-line'
    },
    {
      number: '02',
      title: '体験授業',
      description: '実際の授業を体験していただきます。少人数指導または個別指導をお選びいただけます。',
      icon: 'ri-book-open-line'
    },
    {
      number: '03',
      title: '面談・入塾',
      description: '体験授業後、学習プランや料金についてご説明します。ご納得いただけましたら入塾手続きを行います。',
      icon: 'ri-user-heart-line'
    }
  ];

  return (
    <section className="py-24 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-4">
            無料体験の流れ
          </h2>
          <p className="text-gray-600 text-lg">
            まずは無料体験で学習塾NICKの授業を体感してください
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-3xl p-8 h-full hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-16 h-16 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-3xl text-[#4a90e2]`}></i>
                </div>

                <div className="text-6xl font-bold text-[#4a90e2]/20 mb-4">
                  {step.number}
                </div>

                <h3 className="text-xl font-bold text-[#1a2332] mb-4">
                  {step.title}
                </h3>

                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-4xl text-[#4a90e2]"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-white rounded-3xl p-10 shadow-lg">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl font-bold text-[#1a2332] mb-6">
              無料体験受付中！
            </h3>
            <p className="text-gray-600 mb-8 leading-relaxed">
              <strong>廿日市市大野</strong>の学習塾NICKでは、<strong>無料体験授業</strong>を随時受け付けております。<strong>少人数指導</strong>または<strong>個別指導</strong>をお選びいただき、実際の授業を体験してください。<strong>定期テスト対策</strong>や<strong>高校受験対策</strong>について、詳しくご説明いたします。<strong>廿日市市</strong>、<strong>宮島</strong>、<strong>阿品</strong>、<strong>大竹市</strong>など周辺地域からもお気軽にお越しください。
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/trial"
                className="bg-[#4a90e2] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#3a7bc8] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                無料体験に申し込む
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
              <a
                href="tel:0829-78-1638"
                className="bg-white border-2 border-[#1a2332] text-[#1a2332] px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#1a2332] hover:text-white transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                電話で相談する
              </a>
            </div>

            <p className="text-sm text-gray-500 mt-6">
              ※体験授業は保護者様の同席も可能です。お気軽にお問い合わせください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
